import { registerBlockType } from "@wordpress/blocks";
import Edit from "./edit";
import Save from "./save";
import metadata from "./block.json";
import "./style.scss";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="m12.7,22.8c-.8,0-1.5-.3-2.1-.9L2.1,13.4c-.7-.7-1-1.6-.9-2.5l1.1-7.6c.1-.5.5-.9,1-1l7.6-1.1c.9-.1,1.8.2,2.5.9l8.5,8.5c1.1,1.1,1.2,3,.1,4.1l-7.4,7.3c-.5.5-1.2.8-1.9.8ZM3.8,3.8l-1.1,7.3c-.1.4.1.9.4,1.2l8.5,8.5c.6.6,1.4.6,1.9.1l7.3-7.3c.5-.5.5-1.4-.1-1.9L12.2,3.2c-.3-.3-.8-.5-1.2-.4h0l-7.2,1Zm7.2-1.8h0Z"
          stroke-width="0"
        />
        <path
          d="m11,6.7h1.2s.1,0,.1.1v1.2s0,.1.1.1c.4.1.8.2,1.2.4.6.4.9.9.9,1.6h-1.4s-.1,0-.1-.1c-.1-.3-.2-.5-.5-.7-.6-.3-1.1-.3-1.7,0-.2.1-.4.3-.5.5-.1.3,0,.6.3.8s.6.2.8.3c.4.1.8.2,1.2.3s.7.2,1,.5c.3.2.5.6.6.9.1.5.1,1-.2,1.5-.2.4-.6.7-1,.9-.2.1-.4.2-.7.2q-.1,0-.1.1v1.2q0,.1-.1.1h-1.1q-.1,0-.1-.1v-1.2q0-.1-.1-.1c-.4-.1-.8-.2-1.1-.5-.5-.4-.8-.9-.9-1.5,0,0,0-.1.1-.1h1.4c.1.4.3.7.7.8s.9.1,1.3,0c.3-.1.5-.4.5-.8,0-.2-.1-.4-.3-.5-.3-.2-.5-.2-.8-.3-.4-.1-.8-.2-1.2-.3-.3-.1-.7-.2-1-.4-.4-.3-.6-.6-.6-1.1-.1-.5,0-1,.2-1.4.3-.5.6-.8,1.1-1,.2,0,.5-.1.7-.1q.1,0,.1-.1v-1.2Z"
          stroke-width="0"
        />
      </svg>
    ),
  },
});
